module.exports = __webpack_public_path__ + "img/symbols.b4a6307c.png";